// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainIncassocode =
  (typeof SUREbusinessCommonDomainIncassocode)[keyof typeof SUREbusinessCommonDomainIncassocode];

export const SUREbusinessCommonDomainIncassocode = {
  AE: 'AE',
  MN: 'MN',
  TG: 'TG',
  TN: 'TN',
  NT: 'NT',
  MI: 'MI',
  AC: 'AC',
  CA: 'CA',
  CM: 'CM',
  CN: 'CN',
  GN: 'GN',
  LA: 'LA',
  MM: 'MM',
  MZ: 'MZ',
  NA: 'NA',
  PO: 'PO',
  RG: 'RG',
  RN: 'RN',
  RP: 'RP',
  RV: 'RV',
  VB: 'VB',
  VM: 'VM',
  VN: 'VN',
} as const;
